import { render, staticRenderFns } from "./search-bar.vue?vue&type=template&id=20cd5ec8&scoped=true&"
import script from "./search-bar.vue?vue&type=script&lang=js&"
export * from "./search-bar.vue?vue&type=script&lang=js&"
import style0 from "./search-bar.vue?vue&type=style&index=0&id=20cd5ec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd5ec8",
  null
  
)

export default component.exports